import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CreateContractModal = ({ show, onClose, onSubmit, isCreating }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (show) setName("");
  }, [show]);

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    onSubmit(name.trim() || "Untitled Template");
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="contract-modal-dialog contract-create-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>New contract template</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <label className="contract-modal-label">Contract name</label>
          <input
            className="contract-modal-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            placeholder="e.g. Residential Agreement"
          />
          <p className="contract-modal-hint">
            Morph will pre-load the InterNACHI standard PIA as a starting point.
            You can edit it freely.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isCreating}>
            {isCreating ? "Creating…" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateContractModal;
